import { useMemo, useCallback } from 'react';

export function useSessionFlag<T>(key: string) {
  const value = useMemo(() => {
    const storedValue = sessionStorage.getItem(key);
    if (storedValue) {
      try {
        const parsed = JSON.parse(storedValue);
        return parsed ?? null;
      } catch (error) {
        console.error(
          `Error parsing session storage value for key "${key}":`,
          error,
        );
        return null;
      }
    }
    return null;
  }, [key]);

  const setValue = useCallback((newValue: T) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(newValue));
    } catch (error) {
      console.error(
        `Error setting session storage value for key "${key}":`,
        error,
      );
    }
  }, [key]);

  return [value, setValue] as const;
}
